import React from 'react'
import { InfoPill, coreUtils } from '@adc/ui-morpheus'
import type { InfoPillProps } from '@adc/ui-core'
import * as graph from '@adc/sdk'
import { statusColorMapper } from './utils'

// Direct mapping based on statusColorMapper return values
const LIGHT_COLOR_MAPPING = {
  success: 'success-light' as string,
  info: 'info-light' as string,
  error: 'error-light' as string,
  warning: 'caution-extra-light' as string,
  default: 'gray-extra-light' as string,
} as const

interface StatusPillProps {
  status?: graph.enums.CognitionEvaluationGroupStatus

  size?: InfoPillProps['size']
  [key: string]: unknown
}

export type { StatusPillProps }

/**
 * StatusPill component displays evaluation status as a colored pill
 * @param props - Component props
 * @param props.status - The status value to display
 * @param props.size - Size variant of the pill (default: 'small')
 */
const StatusPill: React.FC<StatusPillProps> = ({
  status,
  size = 'x-small',
  ...props
}) => {
  if (!status) return null

  const colorKey = statusColorMapper(status)
  const backgroundColor =
    LIGHT_COLOR_MAPPING[colorKey as keyof typeof LIGHT_COLOR_MAPPING] ||
    LIGHT_COLOR_MAPPING.default

  return (
    <InfoPill
      // eslint-disable-next-line
      content={coreUtils.formatters.formatEnum(status).toUpperCase()}
      // @ts-ignore color mapping and colorKey stuff above needs to be typed
      foregroundColor={colorKey}
      // @ts-ignore color mapping and colorKey stuff above needs to be typed
      backgroundColor={backgroundColor}
      size={size}
      {...props}
    />
  )
}

export default StatusPill
